import { Database } from "lucide-react";

export function EmptyMini({ label }) {
  return <div className="empty-mini" data-testid="empty-mini-state"><Database className="h-4 w-4" /> {label}</div>;
}
